import {Component, OnInit, inject, DestroyRef, Input} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import { SizingStatus } from '../deploy-sizing.component';



@Component({
  selector: 'app-sizing',
  templateUrl: './sizing.component.html',
  styleUrl: './sizing.component.scss',
  standalone: false
})

export class SizingComponent implements OnInit {
    private destroyRef = inject(DestroyRef);

  @Input() active = false;
  @Input() completed = false;
  @Input() failed = false;
  @Input() sizingStatus!: SizingStatus;
  @Input() createdDate?: string;
  @Input() createdBy?: string;
  SizingStatus = SizingStatus
  instanceId: string;
  isDateLoading = true;
  
  constructor(private activatedRoute: ActivatedRoute, private dialog: MatDialog,) {
  }

   ngOnInit(): void {
    this.instanceId = this.activatedRoute.snapshot.params.id;
  }

  ngOnChanges(): void {
    if (this.createdDate) {
      this.isDateLoading = false;
    }
  }
  
   /* Formats a given date into "MMM dd, yyyy" format (e.g., Feb 18, 2026) */
  private formatDate(date?: string | Date): string {
  if (!date) {
    return '-';
  }

  return new Date(date).toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric'
  }).replace(' ', ' ');
}

/* Returns the formatted sizing creation date for UI display. */
  get formattedDate(): string {
    return this.formatDate(this.createdDate);
  }
}
